import React, { type Ref, forwardRef, type ComponentType } from 'react';
import type { GlyphProps } from '@atlaskit/icon';
import type { TriggerProps } from '@atlaskit/popup';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';

interface Props extends Partial<TriggerProps> {
	InviteTeamIcon: ComponentType<GlyphProps>;
	isInviteTeamDialogOpen: boolean;
	setIsInviteTeamDialogOpen: (isOpen: boolean) => void;
	children: React.ReactNode;
}

export const InviteTeamDialogTriggerWithRef = forwardRef((props: Props, ref?: Ref<HTMLElement>) => (
	<MenuItem
		{...props}
		analytics={{ itemId: 'invite-team' }}
		iconBefore={<props.InviteTeamIcon label="" />}
		isSelected={props.isInviteTeamDialogOpen}
		onClick={() => {
			props.setIsInviteTeamDialogOpen(!props.isInviteTeamDialogOpen);
		}}
		ref={ref}
		testId="navigation-apps-sidebar-servicedesk.common.ui.invite-team-item.invite-team-dialog-trigger.menu-item"
	>
		{props.children}
	</MenuItem>
));
